// src/components/ui/Select.js
import React from 'react';

const Select = ({ label, options, placeholder = '...', required, ...p }) => (
  <div className="space-y-1.5">
    {label && (
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
        {label}
        {required && <span className="text-rose-500 ml-1">*</span>}
      </label>
    )}
    <select
      {...p}
      required={required}
      className="w-full px-4 py-3 bg-gray-50 dark:bg-gray-800 border-2 border-gray-100 dark:border-gray-700 focus:border-rose-300 dark:focus:border-rose-500 rounded-xl dark:text-gray-100 cursor-pointer focus:outline-none transition"
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </div>
);

export default Select;
